import { RATING_STATUS } from './constants';

export const RATING_STATUS_DATA = {
  [RATING_STATUS.NEW]: {
    id: RATING_STATUS.NEW,
    name: 'Ожидает решения',
    attrs: {
      color: 'ui-warning',
      get textColor() {
        return `${this.color}--text`;
      },
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
    },
  },
  [RATING_STATUS.CONFIRM]: {
    id: RATING_STATUS.CONFIRM,
    name: 'Заявка принята',
    attrs: {
      color: 'ui-success',
      get textColor() {
        return `${this.color}--text`;
      },
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
    },
  },
  [RATING_STATUS.REJECTED]: {
    id: RATING_STATUS.REJECTED,
    name: 'Заявка отклонена',
    attrs: {
      color: 'ui-error',
      get textColor() {
        return `${this.color}--text`;
      },
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
    },
  },
};

export default {
  RATING_STATUS_DATA,
};
